import { Typography } from "@mui/material";
import { BuilderDefaultComponentProps } from "./BuilderH1";
import React from "react";

export default function BuilderH3(props: BuilderDefaultComponentProps) {
  return (
    <Typography
      component="h3"
      sx={{
        all: "unset",
      }}
    >
      {props.text}
    </Typography>
  );
}
